/** What the landing lists, shared by the app's Welcome screen and its prerendered HTML (prerender.tsx). */
export const SEO_MODES = ['classic', 'royale', 'powerups', 'friends', 'teams', 'daily'] as const;
export const SEO_FAQ = ['q1', 'q2', 'q3', 'q4', 'q5'] as const;
/** Each mode card's emoji and accent color. */
export const MODE_LOOK: Record<(typeof SEO_MODES)[number], { icon: string; color: string }> = {
  classic: { icon: '🐍', color: '#34f5a0' },
  royale: { icon: '👑', color: '#ffd166' },
  powerups: { icon: '⚡', color: '#2f9bff' },
  friends: { icon: '🎉', color: '#ff7ac6' },
  teams: { icon: '🛡️', color: '#a855f7' },
  daily: { icon: '📅', color: '#ff8a5b' },
};
export const TRUST = [
  { id: 'noDownload', icon: '⚡' },
  { id: 'free', icon: '🎁' },
  { id: 'friends', icon: '👥' },
] as const;
export const STEPS = ['s1', 's2', 's3'] as const;
/** Down-pointing chevron that turns over when an FAQ answer is open. */
export const CHEVRON = 'm6 9 6 6 6-6';

/** The landing hero, recorded with scripts/clip/record.mjs. A new recording gets a new number: the files are cached for 30 days. */
export const HERO_CLIP = `${import.meta.env.BASE_URL}video/snake-feast-gameplay-3.mp4`;
export const HERO_POSTER = `${import.meta.env.BASE_URL}video/snake-feast-gameplay-3.webp`;
